import { isObject } from "./utils";

/** Errors arriving in the body of server error responses. */
export let ServerError = /*#__PURE__*/function (ServerError) {
  ServerError["MismatchingRelationshipVersion"] = "mismatchingRelationshipVersion";
  ServerError["PhoneValidationFailed"] = "phoneValidationFailed";
  ServerError["DuplicateContact"] = "duplicateContact";
  ServerError["UserAlreadyInBusiness"] = "USER_ALREADY_IN_BUSINESS";
  ServerError["UnknownError"] = "unknownError";
  ServerError["BuyerUserAssociatedWithVendor"] = "BuyerUserAssociatedWithVendor";
  ServerError["BankTransferAccountBlocked"] = "bankTransferAccountBlocked";
  ServerError["DuplicateNameExists"] = "DUPLICATE_NAME_EXISTS";
  ServerError["InvalidRelationshipStatus"] = "INVALID_RELATIONSHIP_STATUS";
  ServerError["ServiceTemplateAlreadyExists"] = "SERVICE_TEMPLATE_ALREADY_EXISTS";
  ServerError["NameAlreadyExists"] = "NAME_ALREADY_EXISTS";
  ServerError["UserAlreadyAffiliatedWithBusiness"] = "USER_ALREADY_AFFILIATED_WITH_BUSINESS";
  ServerError["PendingInvitationAlreadyExists"] = "PENDING_INVITATION_ALREADY_EXISTS";
  ServerError["RecipientNotFound"] = "RECIPIENT_NOT_FOUND";
  ServerError["InvalidTeamInvitation"] = "INVALID_TEAM_INVITATION";
  ServerError["FailedToArchiveContactDueToExistingRelationships"] = "FAILED_TO_ARCHIVE_CONTACT_DUE_TO_EXISTING_RELATIONSHIPS";
  ServerError["ContactVersionMismatch"] = "CLIENT_CONTACT_VERSION_MISMATCH";
  ServerError["ContactNotEditable"] = "CLIENT_CONTACT_NOT_EDITABLE";
  ServerError["IncorrectStatusForPaidExternally"] = "incorrectStatusForPaidExternally";
  ServerError["RelationshipAlreadyApproved"] = "RELATIONSHIP_ALREADY_APPROVED";
  ServerError["UserWithEmailAlreadyExists"] = "USER_WITH_EMAIL_ALREADY_EXISTS";
  ServerError["RelationshipAlreadyTerminated"] = "RELATIONSHIP_ALREADY_TERMINATED";
  ServerError["ReviewerEmailIsSimilarToSellerEmail"] = "REVIEWER_EMAIL_IS_SIMILAR_TO_SELLER_EMAIL";
  ServerError["AdditionalRecipientUserAssociatedWithVendor"] = "ADDITIONAL_RECIPIENT_USER_ASSOCIATED_WITH_VENDOR";
  ServerError["DuplicateReviewerEmail"] = "DUPLICATE_REVIEWER_EMAIL";
  ServerError["CantCreateAgreementExternallyFromDraftWithServiceBundles"] = "CANT_CREATE_AGREEMENT_EXTERNALLY_FROM_DRAFT_WITH_SERVICE_BUNDLES";
  ServerError["UserAlreadySigned"] = "USER_ALREADY_SIGNED";
  ServerError["InvoiceWasVoided"] = "INVOICE_WAS_VOIDED";
  ServerError["InvoiceAlreadyApproved"] = "INVOICE_ALREADY_APPROVED";
  ServerError["NoAmendmentsToApprove"] = "NO_AMENDMENTS_TO_APPROVE";
  ServerError["EmailAlreadyRegistered"] = "EMAIL_ALREADY_REGISTERED";
  ServerError["InvalidOTP"] = "INVALID_OTP";
  ServerError["InvalidCurrentPassword"] = "INVALID_CURRENT_PASSWORD";
  ServerError["AdHocChargeNotFound"] = "AD_HOC_CHARGE_NOT_FOUND";
  ServerError["InvalidScopeMissingUserInfo"] = "INVALID_SCOPE_MISSING_USER_INFO";
  ServerError["InvalidScopeMissingGmailSend"] = "INVALID_SCOPE_MISSING_GMAIL_SEND";
  ServerError["InvalidKeeperCredentials"] = "INVALID_KEEPER_CREDENTIALS";
  ServerError["BulkBillAlreadyInProgress"] = "BATCH_ALREADY_IN_PROGRESS";
  ServerError["InvoiceRefundAmountExceeds"] = "INVOICE_REFUND_AMOUNT_EXCEEDS";
  ServerError["InvoiceRefundAmountLessThanZero"] = "INVOICE_REFUND_AMOUNT_LESS_THAN_ZERO";
  ServerError["InvoiceIsFullyRefunded"] = "INVOICE_IS_FULLY_REFUNDED";
  ServerError["InvoiceCalculateRefundParseQueryFailed"] = "INVOICE_CALCULATE_REFUND_PARSE_QUERY_FAILED";
  ServerError["InvoiceIsNotReadyForRefund"] = "INVOICE_IS_NOT_READY_FOR_REFUND";
  ServerError["InvoiceAlreadyHasOneRefundNotRefunded"] = "INVOICE_ALREADY_HAS_ONE_REFUND_NOT_REFUNDED";
  ServerError["InvoiceRefundInvalidAmount"] = "INVOICE_REFUND_INVALID_AMOUNT";
  ServerError["InvoiceRefundFeesNotSupported"] = "INVOICE_REFUND_FEES_NOT_SUPPORTED";
  ServerError["InvoiceCommandPaymentInvalidFundingSource"] = "INVOICE_COMMAND_PAYMENT_INVALID_FUNDING_SOURCE";
  ServerError["InvalidScheduleTime"] = "INVALID_SCHEDULE_TIME";
  ServerError["DraftAlreadyScheduled"] = "DRAFT_ALREADY_SCHEDULED";
  ServerError["MissingDraftOwnerDetails"] = "MISSING_DRAFT_OWNER_DETAILS";
  ServerError["EmailIsInvalid"] = "email is invalid";
  ServerError["PersonalAccountNotSupported"] = "PERSONAL_ACCOUNT_NOT_SUPPORTED";
  ServerError["DraftIsDeleted"] = "DRAFT_IS_DELETED";
  ServerError["ExplicitApprovalNotAllowedForExternalSign"] = "EXPLICIT_APPROVAL_NOT_ALLOWED_FOR_EXTERNAL_SIGN";
  ServerError["MultiVendorCustomerNotEditable"] = "MULTI_VENDOR_CUSTOMER_NOT_EDITABLE";
  ServerError["ClientNotOwnedByVendor"] = "CLIENT_NOT_OWNED_BY_VENDOR";
  ServerError["APIKeyNotFound"] = "API_KEY_NOT_FOUND";
  ServerError["APIKeyRenameFailed"] = "API_KEY_RENAME_FAILED";
  ServerError["AccountAlreadyExists"] = "ACCOUNT_ALREADY_EXISTS";
  ServerError["InvoiceNotVoided"] = "INVOICE_NOT_VOIDED";
  ServerError["InvoiceNotPaidExternally"] = "INVOICE_NOT_PAID_EXTERNALLY";
  ServerError["LegalTermsNameAlreadyExists"] = "LEGAL_TERMS_NAME_ALREADY_EXISTS";
  return ServerError;
}({});
const knownPlaidErrors = [ServerError.BankTransferAccountBlocked];
const stripeErrorKeys = ['code', 'doc_url', 'status', 'message', 'param', 'request_id', 'type'];
const contactModifiedErrorText = 'This contact was already modified by someone else. Please refresh the page and try again.';
export let CreateRelationshipError = /*#__PURE__*/function (CreateRelationshipError) {
  CreateRelationshipError["MissingContact"] = "missingContact";
  CreateRelationshipError["MissingServices"] = "missingServices";
  CreateRelationshipError["OptionalServices"] = "optionalServices";
  CreateRelationshipError["MultipleRecipients"] = "multipleRecipients";
  CreateRelationshipError["MissingDetails"] = "missingDetails";
  CreateRelationshipError["Member"] = "member";
  CreateRelationshipError["Phone"] = "phone";
  CreateRelationshipError["Name"] = "name";
  CreateRelationshipError["ReviewerSimilarToSeller"] = "reviewerSimilarToSeller";
  CreateRelationshipError["DuplicateReviewerEmail"] = "duplicateReviewerEmail";
  CreateRelationshipError["PackagesForExternallySign"] = "packagesForExternallySign";
  CreateRelationshipError["Unknown"] = "unknown";
  CreateRelationshipError["DraftIsDeleted"] = "draftIsDeleted";
  CreateRelationshipError["ExplicitApprovalNotAllowedForExternalSign"] = "explicitApprovalNotAllowedForExternalSign";
  return CreateRelationshipError;
}({});
export class ErrorResponse {
  constructor(maybeAxiosError) {
    this.maybeAxiosError = maybeAxiosError;
    if (maybeAxiosError instanceof ErrorResponse) {
      this.status = null;
      Object.assign(this, maybeAxiosError);
    } else {
      this.status = isObject(this.maybeAxiosError) && 'response' in this.maybeAxiosError && isObject(this.maybeAxiosError.response) && typeof this.maybeAxiosError.response.status === 'number' && this.maybeAxiosError.response.status > 0 ? this.maybeAxiosError.response.status : null;
      this.body = isObject(this.maybeAxiosError) && 'response' in this.maybeAxiosError && isObject(this.maybeAxiosError.response) && this.maybeAxiosError.response.data;
    }
  }
  hasPhoneValidationError() {
    var _this$body$validation;
    return isObject(this.body) && 'validationErrors' in this.body && Array.isArray(this.body.validationErrors) && ((_this$body$validation = this.body.validationErrors.at(0)) === null || _this$body$validation === void 0 ? void 0 : _this$body$validation.includes('e164'));
  }
  hasServerError(type) {
    const typeAsArray = Array.isArray(type) ? type : [type];
    const body = this.body;
    if (typeof body === 'string') {
      return typeAsArray.some(t => body === t);
    } else if (isObject(body)) {
      const knownErrorKeys = ['error', 'errorCode'];
      return knownErrorKeys.some(key => key in body && typeAsArray.some(t => t === body[key]));
    } else {
      return false;
    }
  }
  hasStatus(status) {
    return this.status != null && status.includes(this.status);
  }
  parseStripeError() {
    if (isObject(this.body) && 'error' in this.body && typeof this.body.error === 'string') {
      try {
        const parsed = JSON.parse(this.body.error);
        return stripeErrorKeys.every(key => key in parsed) ? parsed : null;
      } catch (_unused) {
        return null;
      }
    } else {
      return null;
    }
  }
  isStripeError() {
    return this.parseStripeError() != null;
  }
  isPlaidError() {
    return this.hasServerError(knownPlaidErrors);
  }
  isTooManyAttemptsError() {
    return this.status === 429;
  }
  validationErrorCode() {
    return isObject(this.body) && Array.isArray(this.body.errors) && isObject(this.body.errors[0]) ? this.body.errors[0].code || null : null;
  }
  createRelationshipDisableSentry() {
    const {
      id
    } = this.createRelationshipErrorText();
    return id !== CreateRelationshipError.Unknown;
  }
  createRelationshipErrorText() {
    const validationErrorCode = this.validationErrorCode();
    if (validationErrorCode) {
      switch (validationErrorCode) {
        case 'required-clientcontactid':
          return {
            id: CreateRelationshipError.MissingContact,
            text: 'Missing contact'
          };
        case 'services_or_service_bundles-services':
        case 'required-services':
          return {
            id: CreateRelationshipError.MissingServices,
            text: 'No services are included'
          };
        case 'not_optional-services':
          return {
            id: CreateRelationshipError.OptionalServices,
            text: "Optional services are not available for agreements approved on your client's behalf"
          };
        case 'empty-reviewers':
          return {
            id: CreateRelationshipError.MultipleRecipients,
            text: 'Multiple recipients are not allowed'
          };
        default:
          return {
            id: CreateRelationshipError.MissingDetails,
            text: 'Missing details'
          };
      }
    } else if (this.hasServerError(ServerError.BuyerUserAssociatedWithVendor)) {
      return {
        id: CreateRelationshipError.Member,
        text: 'Proposals cannot be sent to someone within your own business. Please change contact'
      };
    } else if (this.hasPhoneValidationError()) {
      return {
        id: CreateRelationshipError.Phone,
        text: 'The proposal was not sent because of an invalid phone number, please verify and send again'
      };
    } else if (this.hasServerError(ServerError.NameAlreadyExists)) {
      return {
        id: CreateRelationshipError.Name,
        text: 'A template with this name already exists.'
      };
    } else if (this.hasServerError([ServerError.ReviewerEmailIsSimilarToSellerEmail, ServerError.AdditionalRecipientUserAssociatedWithVendor])) {
      return {
        id: CreateRelationshipError.ReviewerSimilarToSeller,
        text: 'Proposals cannot be sent to someone within your own business. Please change recipient.'
      };
    } else if (this.hasServerError(ServerError.CantCreateAgreementExternallyFromDraftWithServiceBundles)) {
      return {
        id: CreateRelationshipError.PackagesForExternallySign,
        text: "Packages are not available for agreements approved on your client's behalf"
      };
    } else if (this.hasServerError(ServerError.DuplicateReviewerEmail)) {
      return {
        id: CreateRelationshipError.DuplicateReviewerEmail,
        text: 'There are multiple recipients using the same email address.'
      };
    } else if (this.hasServerError(ServerError.DraftIsDeleted)) {
      return {
        id: CreateRelationshipError.DraftIsDeleted,
        text: 'The draft has been deleted.'
      };
    } else if (this.hasServerError(ServerError.ExplicitApprovalNotAllowedForExternalSign)) {
      return {
        id: CreateRelationshipError.ExplicitApprovalNotAllowedForExternalSign,
        text: 'You can’t require clients to explicitly approve the Terms of Service when an agreement is approved on their behalf.'
      };
    } else {
      return {
        id: CreateRelationshipError.Unknown,
        text: 'An internal error occurred, please contact support for further help.'
      };
    }
  }
  saveContactErrorText() {
    if (this.hasPhoneValidationError()) {
      return 'The contact details were not saved because the phone number is invalid';
    } else if (this.hasServerError(ServerError.DuplicateContact)) {
      return 'A contact with the same email address and company name already exists';
    } else if (this.hasServerError(ServerError.ContactVersionMismatch)) {
      return contactModifiedErrorText;
    } else if (this.hasServerError(ServerError.ContactNotEditable)) {
      return 'This contact is not editable';
    } else if (this.hasServerError(ServerError.UserWithEmailAlreadyExists)) {
      return 'A contact with the same email address already exists';
    } else {
      return 'Failed to save contact';
    }
  }
  restoreContactErrorText() {
    if (this.hasServerError(ServerError.ContactVersionMismatch)) {
      return contactModifiedErrorText;
    } else {
      return 'Failed to restore contact';
    }
  }
  archiveContactErrorText() {
    return this.hasServerError(ServerError.FailedToArchiveContactDueToExistingRelationships) ? 'This contact has existing proposals or agreements. Please remove them before archiving.' : this.hasServerError(ServerError.ContactVersionMismatch) ? 'This contact was already modified by someone else. Please refresh the page and try again.' : 'Error archiving a contact';
  }
  updateUserDetailsErrorText() {
    return this.hasServerError(ServerError.InvalidCurrentPassword) ? 'Invalid current password' : 'An error occurred';
  }
  invalidTeamInvitationErrorText() {
    return 'The team invitation is invalid';
  }
  unvoidInvoiceErrorText(invoice) {
    return this.hasServerError(ServerError.InvoiceNotVoided) ? "Invoice ".concat(invoice.formattedNumber, " is no longer voided, please refresh the page") : "Failed to unvoid invoice ".concat(invoice.formattedNumber);
  }
  unmarkPaidExternallyErrorText(invoice) {
    return this.hasServerError(ServerError.InvoiceNotPaidExternally) ? "Invoice ".concat(invoice.formattedNumber, " is no longer paid externally, please refresh the page") : "Failed to unmark as paid externally invoice ".concat(invoice.formattedNumber);
  }
  getLoginFlowData() {
    const context = this.extractContext();
    const loginType = context === null || context === void 0 ? void 0 : context.loginType;
    if (!loginType) {
      return null;
    }
    return loginType;
  }
  getRecipientEmail() {
    const context = this.extractContext();
    const recipientEmail = context === null || context === void 0 ? void 0 : context.recipientEmail;
    if (!recipientEmail) {
      return null;
    }
    return recipientEmail;
  }
  extractContext() {
    if (!this.body || !isObject(this.body) || !('context' in this.body) || !isObject(this.body.context)) {
      return undefined;
    }
    return this.body.context;
  }
}